import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ContentCard } from '@/features/subscriber/ContentCard';
import { useAuth } from '@/lib/auth/useAuth';
import { subscriberQueries } from '@/lib/queries/subscriber';

export const Route = createFileRoute('/subscriber/discover')({
  component: DiscoverRoute,
});

function DiscoverRoute() {
  const { user } = useAuth();
  const recs = useQuery(subscriberQueries.recommendations(user?.id));
  const coldStart = !recs.isLoading && (recs.data?.length ?? 0) === 0;
  // Cold-start fallback: a brand-new subscriber with no reading history gets
  // recency-ordered published content instead of an empty page.
  const fallback = useQuery({
    ...subscriberQueries.latestPublished(),
    enabled: coldStart,
  });

  const items = coldStart ? (fallback.data ?? []) : (recs.data ?? []);

  return (
    <div className="mx-auto max-w-5xl">
      <h1 className="font-serif text-3xl text-ink">Discover</h1>
      <p className="mt-2 font-sans text-sm text-ink/60">
        {coldStart
          ? 'The latest across every tradition. As you read, this shapes itself to you.'
          : 'Shaped by the traditions and topics you spend time with.'}
      </p>
      {items.length === 0 ? (
        <p className="mt-12 text-center font-sans text-sm text-ink/50">Nothing published yet.</p>
      ) : (
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <ContentCard key={item.content_id ?? item.slug} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
